import React from 'react';
import { addQueryParams } from '@perch-labs/warbler';
import { Text, CopyButton } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { referralPath } from 'domain/settings';
import { useReferralData } from 'hooks/use-referral-data.hook';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { BackLink } from 'components/back-link';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import { Page, Container } from 'styles';
import { LinkBackdrop, LinkText } from './referrals.style';

const getCopy = copyFor('referrals');
const { settings } = routes();

export const Referrals = () => {
  const { data, loading, error } = useReferralData();

  if (loading) return <LoadingPage />;
  if (error) {
    return <ErrorPage to={settings} />;
  }

  const { excludeSavingsLanguage } = data || {};

  const referralLink = addQueryParams(
    `${process.env.ARCADIA_WEBSITE_URL}${referralPath}` || '',
    {
      promo: data?.shareableReferralCode,
    }
  );

  return (
    <>
      <BackLink to={settings} />
      <Page
        maxWidth={MAX_SECONDARY_PAGE_WIDTH}
        small={{ margin: { top: '32px' } }}
      >
        <Text textStyle="heading800" tag="h1" margin={{ bottom: '16px' }}>
          {excludeSavingsLanguage
            ? getCopy('impact.title')
            : getCopy('savings.title')}
        </Text>
        <Text margin={{ bottom: '48px' }}>
          {excludeSavingsLanguage
            ? getCopy('impact.subtitle')
            : getCopy('savings.subtitle')}
        </Text>
        <Text textStyle="heading700" tag="h2" margin={{ bottom: '16px' }}>
          {getCopy('linkHeader')}
        </Text>
        <LinkBackdrop
          flex
          justifyContent="space-between"
          alignItems="center"
          xsmall={{
            alignItems: 'flex-start',
            direction: 'column',
          }}
        >
          <LinkText className="notranslate">{referralLink}</LinkText>
          <Container xsmall={{ margin: { top: '24px' } }}>
            <CopyButton
              aria-label={getCopy('copyAriaLabel')}
              copyText={referralLink}
              backgroundless
            />
          </Container>
        </LinkBackdrop>
      </Page>
    </>
  );
};
